import { gql } from '@apollo/client';

export const FUNDER_PROMOTION_RATE = gql`
  query FunderPromotionRate($input: FilterArgs) {
    funderPromotionRate(input: $input) {
      term
      mean
      year
    }
  }
`;
